@if (naytaOtsikko || naytaSuljeRuksi || (kayttajaaImpersonoidaanObservable | async)) {
  <div class="light-blue-text lemon-dialog-header">
    @if (naytaSuljeRuksi || (kayttajaaImpersonoidaanObservable | async)) {
      <button mat-button mat-dialog-close>
        <i style="font-size: 40px; width: 40px; height: 40px; line-height: 40px; display: inline-block" class="icon ion-ios-close"></i>
      </button>
    }
    @if (naytaOtsikko) {
      <h2><ng-content></ng-content></h2>
    }
  </div>
}
